export default __webpack_public_path__ + "assets/curved-6.jpg";